<template>
  <div class="d-flex fd-column ITEM p-b-2">
    <div class="d-flex fd-row" >
      <img
          class="IMAGE m-b-1"
          :src="item.image"
      /><div class="h5 text-bold p-l-2 m-t-1">{{item.title}}</div>
    </div>
    <p>{{item.description}}</p>
  </div>
</template>

<script>

export default {
  name: 'value-props-item',
  props: {
    item: {
      type: Object,
      require: true,
    },
  },
};

</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.TITLE {
  font-size: 22px;
}
.ITEM {
   max-width: 340px;
   text-align: left;
}
.IMAGE {
  align-self: center;
  width:50px;
  height: 50px;
}
</style>
